export async function checkWarehouseAccess(to, store) {
  if (store.state.user.restriction_base !== 'Warehouse') return true

  const warehouseId = to.query?.warehouse_id
  if (!warehouseId) return true

  const channelId = to.params?.id ? +to.params.id : undefined
  const channelCode = to.query?.channel_code

  if (!channelId || !channelCode) {
    const businessList = store.state.user.businessList || []
    if (!businessList.length) return true

    const allowedWarehouseIds = businessList
      .map(b => b.warehouse_id)
      .filter(Boolean)

    if (!allowedWarehouseIds.length) return true

    if (warehouseId === 'all') return true

    return allowedWarehouseIds.includes(warehouseId)
  }

  const businessId =
    store.getters['user/getBusinessIdOnRoleWarehouseOperator'](warehouseId) ||
    to.query.business_id

  let allowedMasterIds = []

  try {
    const normalized = await store.dispatch('warehouse/GETWAREHOUSECHANNELLISTV2', {
      business_id: businessId,
      channel_id: channelId,
      channel_code: channelCode,
    })
    allowedMasterIds = Array.isArray(normalized)
      ? normalized.map(i => i.warehouse_master_id)
      : []
  } catch (e) {
    return true
  }

  if (!allowedMasterIds.length) return true

  return allowedMasterIds.includes(warehouseId)
}